module.exports = __webpack_public_path__ + "static/media/smart_Insights.f5b920ed.svg";